import React, { useEffect, useState } from "react";
import SideBar from "../Components/SideBar";
import { client } from "./Socket";
import { useLocation, useNavigate } from "react-router-dom";
import MapContainer, { getAddressFromLatLng } from "./Maps";
import i18n from "../Components/i18n";
import { useTranslation } from "react-i18next";
import Tooltip from "./Tooltip";
import { DateTime } from "luxon";
import axios from "axios";

export const sendData = (topic, value) => {
  client.publish(topic, value);
};
function parseTimestamp(timestamp) {
  try {
    const [datePart, timePart] = timestamp.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hour, minute, second);
  } catch (e) {
    return new Date();
  }
}
const OnlineIcon = ({ timestamp }) => {
  const [isOnline, setIsOnline] = useState(false);
  useEffect(() => {
    const updateColor = () => {
      const currentTime =
        new Date().getTime() + new Date().getTimezoneOffset() * 60000;
      const date = parseTimestamp(timestamp);
      const lastHeartbeat = date.getTime();
      const timeDifference = (currentTime - lastHeartbeat) / 1000; // Convert to seconds
      const isOnline = timestamp ? timeDifference <= 10 : false; // 10 seconds
      setIsOnline(isOnline);
    };

    updateColor();
    const interval = setInterval(updateColor, 1000);
    return () => clearInterval(interval);
  }, [timestamp]);

  return (
    <>
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: isOnline ? "#28a745" : "#dc3545",
          boxShadow: isOnline ? "0px 0px 8px #28a745" : "none",
          animation: isOnline ? "pulse 1s infinite" : "none",
          marginBlock: "5px",
        }}
      ></div>
      <style>
        {`
      .spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-left-color: #8ec0fc;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        display:flex
      }
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      @keyframes pulse {
        0% {
          box-shadow: 0 0 5px #28a745;
        }
        50% {
          box-shadow: 0 0 15px #28a745;
        }
        100% {
          box-shadow: 0 0 5px #28a745;
        }
      }
    `}
      </style>
    </>
  );
};

export const getDateTimeUsingLocation = async (
  latitude,
  longitude,
  utcTimeString
) => {
  const timestamp = Math.floor(new Date(utcTimeString).getTime() / 1000);
  if (isNaN(timestamp)) {
    return;
  }
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=${timestamp}&key=AIzaSyBajhVyi8KbuKuEPk1osx9M_7qmpg8e1-c`
  );
  const timezoneData = await response.json();

  const utcDate = new Date(utcTimeString);
  // Apply the timezone offset
  const localTime = new Date(utcDate.getTime() + timezoneData.rawOffset * 1000);
  return localTime.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

export const getDateTimeUsingLocation2 = async (
  latitude,
  longitude,
  utcTimeString,
  timezone
) => {
  if (!utcTimeString || typeof utcTimeString !== "string") {
    console.warn("⚠️ Invalid utcTimeString:", utcTimeString);
    return "Invalid Date (no UTC string)";
  }
  const timeString = utcTimeString;
  const format = "dd/MM/yyyy HH:mm:ss"; // Use 's' for single-digit seconds

  // Create a DateTime object
  const parsedTime = DateTime.fromFormat(timeString, format);

  // Convert it to ISO string
  const isoString = parsedTime.isValid
    ? parsedTime.toISO()
    : "Invalid Date Format";

  const specificTimeUTC = DateTime.fromISO(isoString?.slice(0, -10) + "Z", {
    zone: "utc",
  });

  // Convert the time to Asia/Jerusalem timezone08/07/2025 15:36:00
  const jerusalemTime2 = specificTimeUTC.setZone(timezone);
  // Log the result in a readable format
  // console.log(
  //   "Converted Time in Asia/Jerusalem: ",
  //   jerusalemTime2.toLocaleString(DateTime.DATETIME_FULL)
  // );
  // console.log(
  //   jerusalemTime2.toLocaleString({
  //     locale: "en-US",
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     second: "2-digit",
  //     hour12: false, // 24-hour format
  //   })
  // );
  return jerusalemTime2.toLocaleString({
    locale: "en-US",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // 24-hour format
  });
};

function DevicesData({ children, toggleLanguage }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.state) {
      if (localStorage.getItem("loggedin")) {
        navigate("/management");
        return;
      } else {
        navigate("/");
        return;
      }
    } else {
    }
    // eslint-disable-next-line
  }, []);

  const [Enabled, setEnabled] = useState(
    location?.state?.esp_id
      ? location?.state[`${location?.state?.esp_id}/enabled`] !== 1
      : false
  );
  const locationData = location?.state;
  // const setEnabled = { setEnabled2 };

  const [localState, setLocalState] = useState({});
  let configuration_list = [
    "current",
    "time_left",
    "time_on",
    "system_led",
    "filter_led",
    "water_led",
    "blocked_led",
    "system_id",
    "schedule_id",
    "percentage",
    "name",
    "high_thesold",
    "low_thesold",
    "timestamp",
    "filter",
    "enabled",
    "offset",
    "heartbeat",
    "is_notification_enabled",
    "total_time",
    "notification",
    "installation_date",
    "pop_up",
    "whatsapp",
    "sms",
    "is_pop_up_notification_enabled",
    "target_hour",
    "custom_filter_message",
  ];

  const initMap = {
    current: "current",
    time_left: "time_left",
    time_on: "time_on",
    system_led: "system_led",
    filter_led: "filter_led",
    water_led: "water_led",
    blocked_led: "blocked_led",
    system_id: "system_id",
    schedule_id: "schedule_id",
    percentage: "percentage",
    name: "name",
    high_thesold: "high_thesold",
    low_thesold: "low_thesold",
    timestamp: "timestamp",
    filter: "filter",
    enabled: "enabled",
    offset: "offset",
    pop_up: "pop_up",
    whatsapp: "whatsapp",
    sms: "sms",
    is_notification_enabled: "is_notification_enabled",
    is_pop_up_notification_enabled: "is_pop_up_notification_enabled",
    target_hour: "target_hour",
    custom_filter_message: "custom_filter_message",
  };

  const [DeviceData, setDeviceData] = useState({});
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [tooltip1, settooltip1] = useState(false);
  const [tooltip2, settooltip2] = useState(false);
  const [editTime, seteditTime] = useState(false);

  const [tooltip3, settooltip3] = useState(false);
  const [tooltip4, settooltip4] = useState(false);
  const [InstallationTime, setInstallationTime] = useState("");
  const [DeviceTime, setDeviceTime] = useState("Loading....");
  const [DeviceTime1, setDeviceTime1] = useState("Loading....");
  const [EditIntallationTime, setEditIntallationTime] = useState("");
  // Helper function to get the user's location and call the main function
  const getLocalTimeFromUTCWithBrowserLocation = async (utcTimeString) => {
    return new Promise((resolve, reject) => {
      // Request the user's current location
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          try {
            const localTime = await getDateTimeUsingLocation(
              Number(latitude).toFixed(7),
              Number(longitude).toFixed(7),
              utcTimeString
            );

            resolve(localTime);
          } catch (error) {
            resolve(utcTimeString);
          }
        },
        (error) => {
          resolve(utcTimeString);
        }
      );
    });
  };
  const Offset =
    localState[locationData.esp_id + "/" + initMap?.filter_led] === 1 ||
    localState[locationData.esp_id + "/" + initMap?.filter_led] === "1"
      ? parseFloat(localState[locationData.esp_id + "/" + initMap?.offset])
      : 0;

  const Current = parseFloat(
    localState[locationData.esp_id + "/" + initMap?.current]
  );

  var UpdateCurrent = (Current + Offset).toFixed(2).toString();

  // console.log(
  //   "sending the data to the backend ffor the updted offset current: ",
  //   UpdateCurrent
  // );
  useEffect(() => {
    (async () => {
      const time = await getDateTimeUsingLocation2(
        latitude,
        longitude,
        InstallationTime,
        locationData["user"]["timeZone"]
      );
      //   console.log("TIME OUTPUT", time, InstallationTime, latitude, longitude);
      if (time !== undefined) {
        // alert(time);
        // setDeviceTime(time);
        setDeviceTime(InstallationTime);
      }
      if (InstallationTime) {
        const [day, month, year, tim] = InstallationTime?.split(/[/ ]/);
        const formattedDate = `${year}-${month}-${day}T${tim}`;
        const date = new Date(formattedDate);
        if (!isNaN(date?.getTime())) {
          const time2 = await getLocalTimeFromUTCWithBrowserLocation(
            date?.toISOString()
          );
          setDeviceTime1(time2);
        } else {
          setDeviceTime1("Invalid Date");
        }
      }
    })();
    // eslint-disable-next-line
  }, [latitude, longitude, InstallationTime]);

  useEffect(() => {
    if (locationData) {
      fetch(`https://api.db2sg.com/esps`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `HTTP error! Status: ${response?.status} ${response?.statusText}`
            );
          }

          return response.json();
        })
        .then(async (result) => {
          let resData = result;
          if (resData.data) {
            let proData = resData.data?.filter(
              (el) => el.id === locationData?.esp_id
            );

            setDeviceData(proData[0]);
            setAddress(proData[0].location);
            if (proData[0].latitude) {
              setAddress(
                await getAddressFromLatLng(
                  proData[0].latitude,
                  proData[0].longitude
                )
              );
            }
            setLatitude(proData[0].latitude);
            setLongitude(proData[0].longitude);

            setInstallationTime(proData[0].installation_date);

            proData[0]["enabled"] = (locationData?.user?.devices)[
              locationData?.esp_id
            ].enabled
              ? 1
              : 0;
            let tempArr = configuration_list.map((el) => {
              setLocalState((prev) => ({
                ...prev,
                [proData[0].id + "/" + el]: proData[0][el],
              }));
              //console.log(proData[0].id + "/" + el, "proData[0].id + el");
              return proData[0].id + "/" + el;
            });
            client.subscribe(tempArr, (err) => {
              if (!err) {
              } else {
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });

      //////////////update device///////////////
      client.on("message", (topic, message) => {
        // message is Buffer
        setLocalState((prev) => ({ ...prev, [topic]: message.toString() }));

        if (topic === `${locationData.esp_id}/enabled`) {
          (async () => {
            await axios.get(
              `https://api.db2sg.com/users/${locationData.user.id}/${
                locationData.esp_id
              }/${message.toString() === "1"}`
            );
          })();
        }
        // console.log(topic);
        // console.log(message.toString());
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    (async () => {
      if (latitude && longitude) {
        setAddress(await getAddressFromLatLng(latitude, longitude));
        sendData(`${locationData?.esp_id}/latitude`, `${latitude}`);
        sendData(`${locationData?.esp_id}/longitude`, `${longitude}`);
      }
    })();
  }, [latitude, locationData?.esp_id, longitude]);

  useEffect(() => {
    (async () => {
      if (InstallationTime === "Invalid Date") {
        alert("Tried setting Invalid Date");
        return;
      }
      if (InstallationTime) {
        const [day, month, year, time] = InstallationTime.split(/[/ ]/);
        const formattedDate = `${year}-${month}-${day}T${time}`;
        const date = new Date(formattedDate);
        if (!isNaN(date.getTime())) {
          // setDeviceTime(
          //   await getDateTimeUsingLocation2(
          //     latitude,
          //     longitude,
          //     InstallationTime,
          //     locationData["user"]["timeZone"]
          //   )
          // );
          setDeviceTime(InstallationTime);
        } else {
          setDeviceTime("Invalid Date");
        }
      }
    })();
    // eslint-disable-next-line
  }, [InstallationTime, locationData?.esp_id]);
  const [targetHour, setTargetHour] = useState("");
  const fetchdevice = async () => {
    fetch(`https://api.db2sg.com/esps`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response?.status} ${response?.statusText}`
          );
        }
        return response.json();
      })
      .then((result) => {
        if (result && result.data) {
          // 🔹 1. FIND GLOBAL TARGET (id === "test")
          const globalConfig = result.data.find((d) => d.id === "test");

          if (globalConfig?.target_hour) {
            setTargetHour(globalConfig.target_hour); // ✅ GLOBAL TARGET
          }

          // 🔹 2. BUILD DEVICE ARRAY (IGNORE test)
          let x = { ...location.state.devices };

          let arr = Object.keys(x)
            .filter((e) => e !== "test") // 🚫 safety
            .map((e) => {
              const deviceFromResult = result.data.find((d) => d.id === e);
              return {
                esp_id: e,
                heartbeat: deviceFromResult?.heartbeat || null,
                ...x[e],
              };
            });
        }
      })

      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchdevice();

    // eslint-disable-next-line
  }, []);
  // console.log(
  //   "################################## check the data of the notification",
  //   localState[locationData?.esp_id + "/" + initMap?.is_notification_enabled],
  //   locationData
  // );

  const { t } = useTranslation();

  return (
    <>
      <SideBar />
      <div className="topbar" style={{ backgroundColor: "#8ec0fc" }}>
        <div className="container-fluid devices_topbar">
          <div className="row d-flex align-items-center justify-content-evenly">
            <div
              className="col text-center px-3 flex-start"
              style={{
                cursor: "pointer",
                justifyContent: "flex-start",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
              onClick={() => navigate(-1)}
            >
              <span
                className="mb-0"
                style={{
                  color: "#000",
                  fontSize: "98%",
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {locationData?.esp_id}{" "}
              </span>
              <div
                style={{
                  fontWeight: "500",
                  color: "grey",
                  fontSize: "98%",
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                ({locationData?.deviceName})
              </div>
            </div>
            <div
              className="col-2 d-flex align-items-center"
              style={{
                background:
                  "linear-gradient(45deg, #000, #000, #000, #000)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontSize: "98%",
                width: "600px",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div
                  onClick={() => {
                    if (Enabled) {
                      navigate("/schedule", { state: location.state });
                    }
                  }}
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    cursor: "pointer",
                  }}
                  className="text-secondary"
                >
                  {t("Schedule")}
                </div>
                <div
                  onClick={() => {
                    if (Enabled) {
                      navigate("/schedule", { state: location.state });
                    }
                  }}
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src="assets/calendar.png"
                    width={20}
                    height={20}
                    style={{
                      filter:
                      "sepia(0) saturate(140) brightness(0.9) hue-rotate(200deg)",
                    }}
                    alt="Battery"
                  />
                </div>
              </div>
              <div>
                <div
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  {t("Online")}
                </div>

                <div
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <OnlineIcon
                    timestamp={
                      // eslint-disable-next-line
                      localState[locationData?.esp_id + "/" + "heartbeat"]
                    }
                  ></OnlineIcon>
                </div>
              </div>
              <div>
                <div
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  {t("Current")}
                </div>
                <div
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                  className="mb-0 text-secondary "
                >
                  {Current ? UpdateCurrent : "0"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  {t("TimeLeft")}
                </div>
                <div
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                  className="mb-0 text-secondary"
                >
                  {" "}
                  {Math.floor(
                    localState[
                      locationData?.esp_id + "/" + initMap?.time_left
                    ] / 60
                  )
                    ? Math.floor(
                        localState[
                          locationData?.esp_id + "/" + initMap?.time_left
                        ] / 60
                      )
                    : "00"}
                  HH:
                  {localState[locationData?.esp_id + "/" + initMap?.time_left] %
                  60
                    ? localState[
                        locationData?.esp_id + "/" + initMap?.time_left
                      ] % 60
                    : "00"}
                  MM
                </div>
              </div>
              <div>
                <div
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    color: "#000",
                  }}
                >
                  {i18n.language === "en" ? "Hebrew" : "Hebrew"}
                </div>
                <div
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={i18n.language === "he"}
                      onChange={toggleLanguage}
                      name="loading"
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        <div
          className="container-fluid d-flex justify-content-center align-items-center py-2"
          style={{ color: "#F5FAFA" }}
        >
          <div className="row w-100 justify-content-center">
            <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
              <div className="settings-card px-2 py-2">
                <div
                  className="scrollable-content"
                  style={{
                    // maxHeight: "670px",
                    overflowY: "auto",
                    paddingRight: "10px",
                  }}
                >
                  <div className="" style={{ marginBottom: 0 }}>
                    <p
                      style={{
                        textAlign: i18n.language === "en" ? "left" : "right",
                      }}
                    >
                      <b>{t(`Time Zone`)}</b>
                    </p>
                    <p
                      style={{
                        color: "#8ec0fc",
                        fontSize: "92%",
                        fontWeight: "500",
                        textAlign: i18n.language === "en" ? "left" : "right",
                      }}
                    >
                      {locationData ? locationData["user"]["timeZone"] : ""}
                    </p>
                  </div>
                  <hr />
                  {[
                    {
                      name: "System ON LED",
                      status:
                        localState[
                          locationData?.esp_id + "/" + initMap?.system_led
                        ],
                      imageSrc:
                        localState[
                          locationData?.esp_id + "/" + initMap?.system_led
                        ] === 1 ||
                        localState[
                          locationData?.esp_id + "/" + initMap?.system_led
                        ] === "1"
                          ? "assets/record.png"
                          : "assets/circle.png",
                      color: "",
                    },
                    {
                      name: "Filter ON LED",
                      status:
                        localState[
                          locationData?.esp_id + "/" + initMap?.filter_led
                        ],
                      imageSrc:
                        localState[
                          locationData?.esp_id + "/" + initMap?.filter_led
                        ] === 1 ||
                        localState[
                          locationData?.esp_id + "/" + initMap?.filter_led
                        ] === "1"
                          ? "assets/record.png"
                          : "assets/circle.png",
                      color: "hue-rotate(60deg) brightness(0.4) saturate(10.5)",
                    },
                    {
                      name: "No Water LED",
                      status:
                        localState[
                          locationData?.esp_id + "/" + initMap?.water_led
                        ],
                      imageSrc:
                        localState[
                          locationData?.esp_id + "/" + initMap?.water_led
                        ] === 1 ||
                        localState[
                          locationData?.esp_id + "/" + initMap?.water_led
                        ] === "1"
                          ? "assets/record.png"
                          : "assets/circle.png",
                      color:
                        "hue-rotate(220deg) brightness(0.2) saturate(190.5)",
                    },
                    {
                      name: "High Current / Filter Blocked LED",
                      status:
                        localState[
                          locationData?.esp_id + "/" + initMap?.blocked_led
                        ],
                      imageSrc:
                        localState[
                          locationData?.esp_id + "/" + initMap?.blocked_led
                        ] === 1 ||
                        localState[
                          locationData?.esp_id + "/" + initMap?.blocked_led
                        ] === "1"
                          ? "assets/record.png"
                          : "assets/circle.png",
                      color: "hue-rotate(600deg) brightness(1.2) saturate(1.8)",
                    },
                  ].map((item, index, array) => (
                    <div key={index}>
                      <div className="d-flex justify-content-between align-items-center">
                        {i18n.language === "en" ? (
                          <>
                            <div>
                              <h6
                                style={{
                                  textAlign:
                                    i18n.language === "en" ? "left" : "right",
                                }}
                              >
                                <b>{t(`${item.name}`)}</b>
                              </h6>
                              <div
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                  textAlign:
                                    i18n.language === "en" ? "left" : "right",
                                }}
                              >
                                {item.status}
                              </div>
                            </div>
                            <div>
                              <img
                                src={item.imageSrc}
                                width={
                                  item.status === 1 || item.status === "1"
                                    ? 22
                                    : 22
                                }
                                height={
                                  item.status === 1 || item.status === "1"
                                    ? 22
                                    : 22
                                }
                                style={{
                                  marginRight:
                                    item.status === 1 || item.status === "1"
                                      ? 12
                                      : 12,
                                  backgroundColor:
                                    item.status === 1 || item.status === "1"
                                      ? null
                                      : "#ccc",
                                  borderRadius: "50px",
                                  filter:
                                    item.status === 1 || item.status === "1"
                                      ? item.color
                                      : "",
                                }}
                                alt={item.color}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div>
                              <img
                                src={item.imageSrc}
                                width={
                                  item.status === 1 || item.status === "1"
                                    ? 22
                                    : 22
                                }
                                height={
                                  item.status === 1 || item.status === "1"
                                    ? 22
                                    : 22
                                }
                                style={{
                                  marginRight:
                                    item.status === 1 || item.status === "1"
                                      ? 12
                                      : 12,
                                  backgroundColor:
                                    item.status === 1 || item.status === "1"
                                      ? null
                                      : "#ccc",
                                  borderRadius: "50px",
                                  filter:
                                    item.status === 1 || item.status === "1"
                                      ? item.color
                                      : "",
                                }}
                                alt={item.color}
                              />
                            </div>
                            <div>
                              <h6
                                style={{
                                  textAlign:
                                    i18n.language === "en" ? "left" : "right",
                                }}
                              >
                                <b>{t(`${item.name}`)}</b>
                              </h6>
                              <p
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "700",
                                  textAlign:
                                    i18n.language === "en" ? "left" : "right",
                                }}
                              >
                                {item.status}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      {index !== array.length - 1 && <hr />}
                    </div>
                  ))}

                  <hr />
                  <div className="" style={{ marginBottom: 0 }}>
                    <p
                      style={{
                        textAlign: i18n.language === "en" ? "left" : "right",
                      }}
                    >
                      <b>{t(`Location`)}</b>
                    </p>
                    <p
                      style={{
                        color: "#8ec0fc",
                        fontSize: "92%",
                        fontWeight: "500",
                        textAlign: i18n.language === "en" ? "left" : "right",
                      }}
                    >
                      {address}
                    </p>
                  </div>

                  <div className="d-flex flex-column">
                    <p
                      style={{
                        textAlign: i18n.language === "en" ? "left" : "right",
                      }}
                      className=""
                    >
                      {t(
                        `Installation Date & Time (Your Time Zone - Taken from Your Browser)`
                      )}
                    </p>
                    {i18n.language === "en" ? (
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <p
                          style={{
                            color: "#8ec0fc",
                            fontSize: "92%",
                            fontWeight: "500",
                            textAlign:
                              i18n.language === "en" ? "left" : "right",
                          }}
                        >
                          {longitude && latitude && InstallationTime
                            ? DeviceTime1 === "Invalid Date"
                              ? "Invalid Date"
                              : DeviceTime1?.slice(3, 5) +
                                "/" +
                                DeviceTime1?.slice(0, 2) +
                                "/" +
                                DeviceTime1?.slice(6, 10) +
                                " " +
                                DeviceTime1?.slice(11, 20)
                            : ""}
                        </p>
                        {editTime ||
                        localStorage.getItem("usertype") === "user" ? null : (
                          <button
                            className="save-btn mt-1"
                            style={{
                              width: "20%",
                              height: "30px",
                              color: "#000",
                            }}
                            onClick={async () => {
                              seteditTime(true);
                            }}
                          >
                            {t("Edit")}
                          </button>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        {editTime ||
                        localStorage.getItem("usertype") === "user" ? null : (
                          <button
                            className="save-btn mt-1"
                            style={{
                              width: "20%",
                              height: "30px",
                              color: "#000",
                            }}
                            onClick={async () => {
                              seteditTime(true);
                            }}
                          >
                            {t("Edit")}
                          </button>
                        )}
                        <p
                          style={{
                            color: "#8ec0fc",
                            fontSize: "92%",
                            fontWeight: "500",
                            textAlign:
                              i18n.language === "en" ? "left" : "right",
                          }}
                        >
                          {longitude && latitude && InstallationTime
                            ? DeviceTime1 === "Invalid Date"
                              ? "Invalid Date"
                              : DeviceTime1?.slice(3, 5) +
                                "/" +
                                DeviceTime1?.slice(0, 2) +
                                "/" +
                                DeviceTime1?.slice(6, 10) +
                                " " +
                                DeviceTime1?.slice(11, 20)
                            : ""}
                        </p>
                      </div>
                    )}
                    {editTime ? (
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        {i18n.language === "en" ? (
                          <>
                            <input
                              value={
                                EditIntallationTime !== null
                                  ? EditIntallationTime
                                  : DeviceTime1 === "Invalid Date"
                                  ? "Invalid Date"
                                  : DeviceTime1?.slice(3, 5) +
                                    "/" +
                                    DeviceTime1?.slice(0, 2) +
                                    "/" +
                                    DeviceTime1?.slice(6, 10) +
                                    " " +
                                    DeviceTime1?.slice(11, 20)
                              }
                              type="text"
                              style={{ width: "50%", color: "#8ec0fc" }}
                              onFocus={() => {
                                if (
                                  EditIntallationTime === null ||
                                  EditIntallationTime === "Invalid Date"
                                ) {
                                  setEditIntallationTime(""); // Clear the field properly
                                }
                              }}
                              onChange={async (e) => {
                                setEditIntallationTime(e.target.value); // Always update
                              }}
                              placeholder="dd/mm/yyyy HH:mm:ss"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                pattern:
                                  "\\d{2}/\\d{2}/\\d{4} \\d{2}:\\d{2}:\\d{2}",
                                title: "Format: DD/MM/YYYY HH:mm:ss",
                              }}
                              className="input-field"
                            />
                            <button
                              className="save-btn mt-1"
                              style={{
                                width: "20%",
                                height: "30px",
                                color: "#000",
                              }}
                              onClick={async () => {
                                const convertToUTCFormat = (dateString) => {
                                  // Parse "DD/MM/YYYY HH:mm:ss"
                                  const [datePart, timePart] =
                                    dateString.split(" ");
                                  const [day, month, year] =
                                    datePart.split("/");
                                  // console.log(
                                  //   `${year}-${month}-${day}T${timePart}Z`,
                                  //   "date"
                                  // );
                                  // Create a proper Date object
                                  const date = new Date(
                                    `${year}-${month}-${day}T${timePart}Z`
                                  );
                                  // console.log(date, "date__________*****");
                                  if (isNaN(date.getTime())) {
                                    return "Invalid Date"; // Safe fallback
                                  }
                                  // console.log(
                                  //   date.toLocaleString("en-GB", {
                                  //     timeZone: "UTC",
                                  //     hour12: false,
                                  //     year: "numeric",
                                  //     month: "2-digit",
                                  //     day: "2-digit",
                                  //     hour: "2-digit",
                                  //     minute: "2-digit",
                                  //     second: "2-digit",
                                  //   })
                                  // );
                                  // Format as UTC
                                  return date.toLocaleString("en-GB", {
                                    timeZone: "UTC",
                                    hour12: false,
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                  });
                                };

                                const utcDate =
                                  convertToUTCFormat(EditIntallationTime);
                                const ourDate = utcDate.replace(",", "");
                                // console.log(ourDate);
                                sendData(
                                  `${locationData?.esp_id}/installation_date`,
                                  `${ourDate}`
                                );

                                setInstallationTime(ourDate);
                                //console.log(ourDate, "ourDate");

                                seteditTime(false);
                              }}
                            >
                              Save
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="save-btn mt-1"
                              style={{
                                width: "20%",
                                height: "30px",
                                color: "#000",
                              }}
                              onClick={async () => {
                                const convertToUTCFormat = (dateString) => {
                                  // Parse "DD/MM/YYYY HH:mm:ss"
                                  const [datePart, timePart] =
                                    dateString.split(" ");
                                  const [day, month, year] =
                                    datePart.split("/");
                                  // console.log(
                                  //   `${year}-${month}-${day}T${timePart}Z`,
                                  //   "date"
                                  // );
                                  // Create a proper Date object
                                  const date = new Date(
                                    `${year}-${month}-${day}T${timePart}Z`
                                  );
                                  // console.log(date, "date__________*****");
                                  if (isNaN(date.getTime())) {
                                    return "Invalid Date"; // Safe fallback
                                  }
                                  // console.log(
                                  //   date.toLocaleString("en-GB", {
                                  //     timeZone: "UTC",
                                  //     hour12: false,
                                  //     year: "numeric",
                                  //     month: "2-digit",
                                  //     day: "2-digit",
                                  //     hour: "2-digit",
                                  //     minute: "2-digit",
                                  //     second: "2-digit",
                                  //   })
                                  // );
                                  // Format as UTC
                                  return date.toLocaleString("en-GB", {
                                    timeZone: "UTC",
                                    hour12: false,
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                  });
                                };

                                const utcDate =
                                  convertToUTCFormat(EditIntallationTime);
                                const ourDate = utcDate.replace(",", "");
                                // console.log(ourDate);
                                sendData(
                                  `${locationData?.esp_id}/installation_date`,
                                  `${ourDate}`
                                );

                                setInstallationTime(ourDate);
                                //  console.log(ourDate, "ourDate");

                                seteditTime(false);
                              }}
                            >
                              Save
                            </button>
                            <input
                              value={
                                EditIntallationTime !== null
                                  ? EditIntallationTime
                                  : DeviceTime1 === "Invalid Date"
                                  ? "Invalid Date"
                                  : DeviceTime1?.slice(3, 5) +
                                    "/" +
                                    DeviceTime1?.slice(0, 2) +
                                    "/" +
                                    DeviceTime1?.slice(6, 10) +
                                    " " +
                                    DeviceTime1?.slice(11, 20)
                              }
                              type="text"
                              style={{ width: "50%", color: "#8ec0fc" }}
                              // onChange={(e) => {
                              //   const inputValue = e.target.value;
                              //       setEditIntallationTime(inputValue)
                              // }}
                              onFocus={() => {
                                if (
                                  EditIntallationTime === null ||
                                  EditIntallationTime === "Invalid Date"
                                ) {
                                  setEditIntallationTime(""); // Clear the field properly
                                }
                              }}
                              onChange={(e) => {
                                setEditIntallationTime(e.target.value); // Always update
                              }}
                              placeholder="dd/mm/yyyy HH:mm:ss"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                pattern:
                                  "\\d{2}/\\d{2}/\\d{4} \\d{2}:\\d{2}:\\d{2}",
                                title: "Format: DD/MM/YYYY HH:mm:ss",
                              }}
                              className="input-field"
                            />
                          </>
                        )}
                      </div>
                    ) : null}
                  </div>

                  <hr />

                  <p
                    style={{
                      textAlign: i18n.language === "en" ? "left" : "right",
                    }}
                  >
                    {t("Installation Date & Time")} (Device Time Zone -{" "}
                    {address})
                  </p>
                  <p
                    style={{
                      color: "#8ec0fc",
                      fontSize: "92%",
                      fontWeight: "500",
                      textAlign: i18n.language === "en" ? "left" : "right",
                    }}
                  >
                    {longitude && latitude && InstallationTime
                      ? DeviceTime === "Invalid Date"
                        ? "Invalid Date"
                        : DeviceTime?.slice(0, 2) +
                          "/" +
                          DeviceTime?.slice(3, 5) +
                          "/" +
                          DeviceTime?.slice(6, 10) +
                          " " +
                          DeviceTime?.slice(11, 20)
                      : ""}
                  </p>
                  <hr />

                  <div className="d-flex justify-content-between align-items-center">
                    {i18n.language === "en" ? (
                      <>
                        <div>
                          <h6>{t("Total Work Time")}</h6>
                          <p
                            style={{
                              color: "#8ec0fc",
                              fontSize: "92%",
                              fontWeight: "500",
                            }}
                          >
                            {/* {DeviceData?.new_total_time} */}
                            {(() => {
                              const minutes = DeviceData.new_total_time || 0;
                              const hrs = Math.floor(minutes / 60);
                              const mins = minutes % 60;
                              return `${String(hrs).padStart(2, "0")}:${String(
                                mins
                              ).padStart(2, "0")}`;
                            })()}{" "}
                            h
                          </p>
                        </div>
                        {localStorage.getItem("usertype") === "user" ? null : (
                          <button
                            className="save-btn mt-1"
                            style={{ width: "20%", color: "#000" }}
                            onClick={() => {
                              sendData(
                                `${locationData?.esp_id}/reset_total_time`,
                                "0"
                              );
                            }}
                          >
                            {t("Reset")}
                          </button>
                        )}
                      </>
                    ) : (
                      <>
                        {localStorage.getItem("usertype") === "user" ? null : (
                          <button
                            className="save-btn mt-1"
                            style={{ width: "20%", color: "#000" }}
                            onClick={() => {
                              sendData(
                                `${locationData?.esp_id}/reset_total_time`,
                                "0"
                              );
                            }}
                          >
                            {t("Reset")}
                          </button>
                        )}
                        <div>
                          <h6>{t("Total Work Time")}</h6>
                          <p
                            style={{
                              color: "#8ec0fc",
                              fontSize: "92%",
                              fontWeight: "500",
                              textAlign:
                                i18n.language === "en" ? "left" : "right",
                            }}
                          >
                            {(() => {
                              const minutes = DeviceData.new_total_time || 0;
                              const hrs = Math.floor(minutes / 60);
                              const mins = minutes % 60;
                              return `${String(hrs).padStart(2, "0")}:${String(
                                mins
                              ).padStart(2, "0")}`;
                            })()}{" "}
                            h
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                  <hr />

                  <p
                    style={{
                      textAlign: i18n.language === "en" ? "left" : "right",
                    }}
                  >
                    {t("Firmware Version Number")}
                  </p>
                  <p
                    style={{
                      color: "#8ec0fc",
                      fontSize: "92%",
                      fontWeight: "500",
                      textAlign: i18n.language === "en" ? "left" : "right",
                    }}
                  >
                    {DeviceData?.version}
                  </p>
                  {localStorage.getItem("usertype") === "user" ? null : (
                    <>
                      <hr />
                      <p
                        style={{
                          textAlign: i18n.language === "en" ? "left" : "right",
                        }}
                      >
                        <b>{t("Longitude")}</b>
                      </p>
                      <input
                        value={longitude}
                        style={{ color: "#8ec0fc" }}
                        onChange={(e) => {
                          setLongitude(e.target.value);
                        }}
                        type="text"
                        className="input-field"
                      />
                      <hr />
                      <p
                        style={{
                          textAlign: i18n.language === "en" ? "left" : "right",
                        }}
                      >
                        <b>{t("Latitude")}</b>
                      </p>
                      <input
                        value={latitude}
                        style={{ color: "#8ec0fc" }}
                        onChange={(e) => {
                          setLatitude(e.target.value);
                        }}
                        type="text"
                        className="input-field"
                      />
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 d-flex  align-items-center mb-4 mb-md-0">
              <div className="d-flex flex-column">
                <div className="devices_card mb-4" style={{ height: "450px" }}>
                  {latitude && longitude ? (
                    <MapContainer
                      lat={latitude}
                      lng={longitude}
                      maxHeight="100%"
                      maxWidth="100%"
                    />
                  ) : null}
                </div>

                <div className="devices_card p-3">
                  <h4
                    className="text-center"
                    style={{
                      color: "black",
                      fontSize: "92%",
                      fontWeight: "700",
                    }}
                  >
                    {t("Settings")}
                  </h4>
                  <div className="d-flex justify-content-between align-items-center">
                    {i18n.language === "en" ? (
                      <>
                        <div>
                          <h6
                            style={{
                              textAlign: "left",
                              color: "black",
                              fontSize: "92%",
                              fontWeight: "700",
                            }}
                          >
                            {t("Filter")}
                          </h6>
                          <p
                            style={{
                              color: "#8ec0fc",
                              fontSize: "92%",
                              fontWeight: "500",
                            }}
                          >
                            {t("PB Status")}:{" "}
                            {localState[
                              locationData?.esp_id + "/" + initMap?.filter
                            ] === 1 ||
                            localState[
                              locationData?.esp_id + "/" + initMap?.filter
                            ] === "1"
                              ? "ON"
                              : "OFF"}
                          </p>
                        </div>
                        <div>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={
                                localState[
                                  locationData?.esp_id + "/" + initMap?.filter
                                ] === 1 ||
                                localState[
                                  locationData?.esp_id + "/" + initMap?.filter
                                ] === "1"
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                sendData(
                                  `${locationData?.esp_id}/${initMap?.filter}`,
                                  localState[
                                    locationData?.esp_id + "/" + initMap?.filter
                                  ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.filter
                                    ] === "1"
                                    ? `0`
                                    : `1`
                                );
                              }}
                              name="loading"
                            />
                            <span className="slider"></span>
                          </label>
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={
                                localState[
                                  locationData?.esp_id + "/" + initMap?.filter
                                ] === 1 ||
                                localState[
                                  locationData?.esp_id + "/" + initMap?.filter
                                ] === "1"
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                sendData(
                                  `${locationData?.esp_id}/${initMap?.filter}`,
                                  localState[
                                    locationData?.esp_id + "/" + initMap?.filter
                                  ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.filter
                                    ] === "1"
                                    ? `0`
                                    : `1`
                                );
                              }}
                              name="loading"
                            />
                            <span className="slider"></span>
                          </label>
                        </div>
                        <div>
                          <h6
                            style={{
                              textAlign: "left",
                              color: "black",
                              fontSize: "92%",
                              fontWeight: "700",
                            }}
                          >
                            {t("Filter")}
                          </h6>
                          <p
                            style={{
                              color: "#8ec0fc",
                              fontSize: "92%",
                              fontWeight: "500",
                            }}
                          >
                            {t("PB Status")}:{" "}
                            {localState[
                              locationData?.esp_id + "/" + initMap?.filter
                            ] === 1 ||
                            localState[
                              locationData?.esp_id + "/" + initMap?.filter
                            ] === "1"
                              ? "ON"
                              : "OFF"}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                  <hr />
                  {localStorage.getItem("usertype") !== "admin" ? (
                    <div></div>
                  ) : (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        {i18n.language === "en" ? (
                          <>
                            <div>
                              <h6
                                style={{
                                  textAlign: "left",
                                  color: "black",
                                  fontSize: "92%",
                                  fontWeight: "700",
                                }}
                              >
                                {t("Enabled")}
                              </h6>
                              <p
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("Device Enabled")}:{" "}
                                {localState[
                                  locationData?.esp_id + "/" + initMap?.enabled
                                ] === 1 ||
                                localState[
                                  locationData?.esp_id + "/" + initMap?.enabled
                                ] === "1"
                                  ? "Yes"
                                  : "No"}
                              </p>
                            </div>
                            <div>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.enabled
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.enabled
                                    ] === "1"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap?.enabled}`,
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.enabled
                                      ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.enabled
                                        ] === "1"
                                        ? `0`
                                        : `1`
                                    );
                                    setEnabled(
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.enabled
                                      ] !== 1
                                    );
                                  }}
                                  name="loading"
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                          </>
                        ) : (
                          <>
                            <div>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.enabled
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.enabled
                                    ] === "1"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap?.enabled}`,
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.enabled
                                      ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.enabled
                                        ] === "1"
                                        ? `0`
                                        : `1`
                                    );
                                    setEnabled(
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.enabled
                                      ] !== 1
                                    );
                                  }}
                                  name="loading"
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                            <div>
                              <h6
                                style={{
                                  textAlign: "left",
                                  color: "black",
                                  fontSize: "92%",
                                  fontWeight: "700",
                                }}
                              >
                                {t("Enabled")}
                              </h6>
                              <p
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("Device Enabled")}:{" "}
                                {localState[
                                  locationData?.esp_id + "/" + initMap?.enabled
                                ] === 1 ||
                                localState[
                                  locationData?.esp_id + "/" + initMap?.enabled
                                ] === "1"
                                  ? "Yes"
                                  : "No"}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      <hr />
                    </>
                  )}
                  {localStorage.getItem("usertype") !== "admin" &&
                  localStorage.getItem("usertype") !== "sitemanager" ? null : (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        {i18n.language === "en" ? (
                          <>
                            <div style={{ fontSize: "92%" }}>
                              <h6
                                style={{
                                  textAlign: "left",
                                  color: "black",
                                  fontSize: "92%",
                                  fontWeight: "700",
                                }}
                              >
                                {t("filter_notification_enabled")}
                              </h6>
                              <p
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("filter_notification_status")}:{" "}
                                {localState[
                                  locationData?.esp_id +
                                    "/" +
                                    initMap?.is_notification_enabled
                                ] === 1 ||
                                localState[
                                  locationData?.esp_id +
                                    "/" +
                                    initMap?.is_notification_enabled
                                ] === "1"
                                  ? "ON"
                                  : "OFF"}
                              </p>
                            </div>
                            <div>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.is_notification_enabled
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.is_notification_enabled
                                    ] === "1"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap?.is_notification_enabled}`,
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.is_notification_enabled
                                      ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.is_notification_enabled
                                        ] === "1"
                                        ? `0`
                                        : `1`
                                    );
                                  }}
                                  name="loading"
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                          </>
                        ) : (
                          <>
                            <div>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.is_notification_enabled
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.is_notification_enabled
                                    ] === "1"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap?.is_notification_enabled}`,
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.is_notification_enabled
                                      ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.is_notification_enabled
                                        ] === "1"
                                        ? `0`
                                        : `1`
                                    );
                                  }}
                                  name="loading"
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                            <div style={{ fontSize: "92%" }}>
                              <h6
                                style={{
                                  textAlign: "left",
                                  color: "black",
                                  fontSize: "92%",
                                  fontWeight: "700",
                                }}
                              >
                                {t("filter_notification_enabled")}
                              </h6>
                              <p
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("filter_notification_status")}:{" "}
                                {localState[
                                  locationData?.esp_id +
                                    "/" +
                                    initMap?.is_notification_enabled
                                ] === 1 ||
                                localState[
                                  locationData?.esp_id +
                                    "/" +
                                    initMap?.is_notification_enabled
                                ] === "1"
                                  ? "ON"
                                  : "OFF"}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      <h6
                        style={{
                          textAlign: i18n.language === "en" ? "left" : "right",
                          color: "black",
                          fontSize: "85%",
                          fontWeight: "700",
                        }}
                      >
                        <b>{t("target_hour")}</b>
                      </h6>
                      <input
                        value={targetHour}
                        style={{ color: "#8ec0fc" }}
                        onChange={(e) => {
                          setTargetHour(e.target.value);
                          sendData(
                            `${locationData?.esp_id}/${initMap?.target_hour}`,
                            e.target.value
                          );
                        }}
                        type="text"
                        className="input-field"
                      />
                      <h6
                        style={{
                          textAlign: i18n.language === "en" ? "left" : "right",
                          color: "black",
                          fontSize: "85%",
                          fontWeight: "700",
                          marginTop: "20px",
                        }}
                      >
                        <b>{t("custom_message")}</b>
                      </h6>
                      <input
                        value={
                          localState[
                            locationData?.esp_id +
                              "/" +
                              initMap?.custom_filter_message
                          ] || "Please Change the filter"
                        }
                        style={{ color: "#8ec0fc" }}
                        onChange={(e) => {
                          sendData(
                            `${locationData?.esp_id}/${initMap?.custom_filter_message}`,
                            e.target.value
                          );
                        }}
                        type="text"
                        className="input-field"
                      />
                      <hr />
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        {i18n.language === "en" ? (
                          <>
                            <div style={{ fontSize: "92%" }}>
                              <h6
                                style={{
                                  textAlign: "left",
                                  color: "black",
                                  fontSize: "92%",
                                  fontWeight: "700",
                                }}
                              >
                                {t("all_device_popup_notification_enabled")}
                              </h6>
                              <p
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("all_device_popup_notification_status")}:{" "}
                                {localState[
                                  locationData?.esp_id +
                                    "/" +
                                    initMap?.is_pop_up_notification_enabled
                                ] === 1 ||
                                localState[
                                  locationData?.esp_id +
                                    "/" +
                                    initMap?.is_pop_up_notification_enabled
                                ] === "1"
                                  ? "ON"
                                  : "OFF"}
                              </p>
                            </div>
                            <div>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.is_pop_up_notification_enabled
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.is_pop_up_notification_enabled
                                    ] === "1"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap?.is_pop_up_notification_enabled}`,
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.is_pop_up_notification_enabled
                                      ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.is_pop_up_notification_enabled
                                        ] === "1"
                                        ? `0`
                                        : `1`
                                    );
                                  }}
                                  name="loading"
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                          </>
                        ) : (
                          <>
                            <div>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.is_pop_up_notification_enabled
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.is_pop_up_notification_enabled
                                    ] === "1"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap?.is_pop_up_notification_enabled}`,
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.is_pop_up_notification_enabled
                                      ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.is_pop_up_notification_enabled
                                        ] === "1"
                                        ? `0`
                                        : `1`
                                    );
                                  }}
                                  name="loading"
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                            <div style={{ fontSize: "92%" }}>
                              <h6
                                style={{
                                  textAlign: "left",
                                  color: "black",
                                  fontSize: "92%",
                                  fontWeight: "700",
                                }}
                              >
                                {t("all_device_popup_notification_enabled")}
                              </h6>
                              <p
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("all_device_popup_notification_status")}:{" "}
                                {localState[
                                  locationData?.esp_id +
                                    "/" +
                                    initMap?.is_pop_up_notification_enabled
                                ] === 1 ||
                                localState[
                                  locationData?.esp_id +
                                    "/" +
                                    initMap?.is_pop_up_notification_enabled
                                ] === "1"
                                  ? "ON"
                                  : "OFF"}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      <hr />
                      {localState[
                        locationData?.esp_id +
                          "/" +
                          initMap?.is_pop_up_notification_enabled
                      ] === 1 ||
                      localState[
                        locationData?.esp_id +
                          "/" +
                          initMap?.is_pop_up_notification_enabled
                      ] === "1" ? (
                        <>
                          <div className="d-flex justify-content-between align-items-center">
                            {i18n.language === "en" ? (
                              <>
                                <div style={{ paddingTop: "12px" }}>
                                  <p
                                    style={{
                                      color: "#8ec0fc",
                                      fontSize: "92%",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {t("popup")}:{" "}
                                    {localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.pop_up
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.pop_up
                                    ] === "1"
                                      ? "ON"
                                      : "OFF"}
                                  </p>
                                </div>
                                <div>
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.pop_up
                                        ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.pop_up
                                        ] === "1"
                                          ? true
                                          : false
                                      }
                                      onChange={async (e) => {
                                        sendData(
                                          `${locationData?.esp_id}/${initMap?.pop_up}`,
                                          localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.pop_up
                                          ] === 1 ||
                                            localState[
                                              locationData?.esp_id +
                                                "/" +
                                                initMap?.pop_up
                                            ] === "1"
                                            ? `0`
                                            : `1`
                                        );
                                      }}
                                      name="loading"
                                    />
                                    <span className="slider"></span>
                                  </label>
                                </div>
                                <div style={{ paddingTop: "12px" }}>
                                  <p
                                    style={{
                                      color: "#8ec0fc",
                                      fontSize: "92%",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {t("whatsapp")}:{" "}
                                    {localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.whatsapp
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.whatsapp
                                    ] === "1"
                                      ? "ON"
                                      : "OFF"}
                                  </p>
                                </div>
                                <div>
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.whatsapp
                                        ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.whatsapp
                                        ] === "1"
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        sendData(
                                          `${locationData?.esp_id}/${initMap?.whatsapp}`,
                                          localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.whatsapp
                                          ] === 1 ||
                                            localState[
                                              locationData?.esp_id +
                                                "/" +
                                                initMap?.whatsapp
                                            ] === "1"
                                            ? `0`
                                            : `1`
                                        );
                                      }}
                                      name="loading"
                                    />
                                    <span className="slider"></span>
                                  </label>
                                </div>
                                <div style={{ paddingTop: "12px" }}>
                                  <p
                                    style={{
                                      color: "#8ec0fc",
                                      fontSize: "92%",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {t("SMS")}:{" "}
                                    {localState[
                                      locationData?.esp_id + "/" + initMap?.sms
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id + "/" + initMap?.sms
                                    ] === "1"
                                      ? "ON"
                                      : "OFF"}
                                  </p>
                                </div>
                                <div>
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.sms
                                        ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.sms
                                        ] === "1"
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        sendData(
                                          `${locationData?.esp_id}/${initMap?.sms}`,
                                          localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.sms
                                          ] === 1 ||
                                            localState[
                                              locationData?.esp_id +
                                                "/" +
                                                initMap?.sms
                                            ] === "1"
                                            ? `0`
                                            : `1`
                                        );
                                      }}
                                      name="loading"
                                    />
                                    <span className="slider"></span>
                                  </label>
                                </div>
                              </>
                            ) : (
                              <>
                                <div>
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.sms
                                        ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.sms
                                        ] === "1"
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        sendData(
                                          `${locationData?.esp_id}/${initMap?.sms}`,
                                          localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.sms
                                          ] === 1 ||
                                            localState[
                                              locationData?.esp_id +
                                                "/" +
                                                initMap?.sms
                                            ] === "1"
                                            ? `0`
                                            : `1`
                                        );
                                      }}
                                      name="loading"
                                    />
                                    <span className="slider"></span>
                                  </label>
                                </div>
                                <div style={{ paddingTop: "12px" }}>
                                  <p
                                    style={{
                                      color: "#8ec0fc",
                                      fontSize: "92%",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {t("SMS")}:{" "}
                                    {localState[
                                      locationData?.esp_id + "/" + initMap?.sms
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id + "/" + initMap?.sms
                                    ] === "1"
                                      ? "ON"
                                      : "OFF"}
                                  </p>
                                </div>

                                <div>
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.whatsapp
                                        ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.whatsapp
                                        ] === "1"
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        sendData(
                                          `${locationData?.esp_id}/${initMap?.whatsapp}`,
                                          localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.whatsapp
                                          ] === 1 ||
                                            localState[
                                              locationData?.esp_id +
                                                "/" +
                                                initMap?.whatsapp
                                            ] === "1"
                                            ? `0`
                                            : `1`
                                        );
                                      }}
                                      name="loading"
                                    />
                                    <span className="slider"></span>
                                  </label>
                                </div>
                                <div style={{ paddingTop: "12px" }}>
                                  <p
                                    style={{
                                      color: "#8ec0fc",
                                      fontSize: "92%",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {t("whatsapp")}:{" "}
                                    {localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.whatsapp
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.whatsapp
                                    ] === "1"
                                      ? "ON"
                                      : "OFF"}
                                  </p>
                                </div>

                                <div>
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.pop_up
                                        ] === 1 ||
                                        localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.pop_up
                                        ] === "1"
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        sendData(
                                          `${locationData?.esp_id}/${initMap?.pop_up}`,
                                          localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.pop_up
                                          ] === 1 ||
                                            localState[
                                              locationData?.esp_id +
                                                "/" +
                                                initMap?.pop_up
                                            ] === "1"
                                            ? `0`
                                            : `1`
                                        );
                                      }}
                                      name="loading"
                                    />
                                    <span className="slider"></span>
                                  </label>
                                </div>
                                <div style={{ paddingTop: "12px" }}>
                                  <p
                                    style={{
                                      color: "#8ec0fc",
                                      fontSize: "92%",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {t("popup")}:{" "}
                                    {localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.pop_up
                                    ] === 1 ||
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.pop_up
                                    ] === "1"
                                      ? "ON"
                                      : "OFF"}
                                  </p>
                                </div>
                              </>
                            )}
                          </div>
                          <hr />
                        </>
                      ) : null}
                    </>
                  )}
                  {localStorage.getItem("usertype") === "user" ? null : (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            color: "black",
                            fontSize: "92%",
                          }}
                        >
                          {i18n.language === "en" ? (
                            <>
                              <h6
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("Time On")}:{" "}
                                {localState[
                                  locationData?.esp_id + "/" + initMap?.time_on
                                ] > 0
                                  ? localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.time_on
                                    ]
                                  : 10}{" "}
                                min(s)
                              </h6>
                              <div
                                onMouseEnter={() => settooltip1(true)}
                                onMouseLeave={() => settooltip1(false)}
                              >
                                {tooltip1 ? (
                                  <Tooltip
                                    value={
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.time_on
                                      ] > 0
                                        ? localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.time_on
                                          ]
                                        : 10
                                    }
                                    max={20}
                                  />
                                ) : null}
                                <span>1</span>
                                <input
                                  type="range"
                                  min={1}
                                  style={{
                                    accentColor: "#8ec0fc",
                                    width: "230px",
                                  }}
                                  max={20}
                                  value={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.time_on
                                    ] > 0
                                      ? localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.time_on
                                        ]
                                      : 10
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap.time_on}`,
                                      `${e.target.value}`
                                    );
                                  }}
                                />
                                <span>20</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                onMouseEnter={() => settooltip1(true)}
                                onMouseLeave={() => settooltip1(false)}
                              >
                                {tooltip1 ? (
                                  <Tooltip
                                    value={
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.time_on
                                      ] > 0
                                        ? localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.time_on
                                          ]
                                        : 10
                                    }
                                    max={20}
                                  />
                                ) : null}
                                <span>1</span>{" "}
                                <input
                                  type="range"
                                  min={1}
                                  style={{
                                    accentColor: "#8ec0fc",
                                    width: "230px",
                                  }}
                                  max={20}
                                  value={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.time_on
                                    ] > 0
                                      ? localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.time_on
                                        ]
                                      : 10
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap.time_on}`,
                                      `${e.target.value}`
                                    );
                                  }}
                                />
                                <span>20</span>
                              </div>
                              <h6
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("Time On")}:{" "}
                                {localState[
                                  locationData?.esp_id + "/" + initMap?.time_on
                                ] > 0
                                  ? localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.time_on
                                    ]
                                  : 10}{" "}
                                min(s)
                              </h6>
                            </>
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            color: "black",
                            fontSize: "92%",
                          }}
                        >
                          {i18n.language === "en" ? (
                            <>
                              <h6
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("Low Threshold")}:{" "}
                                {
                                  localState[
                                    locationData?.esp_id +
                                      "/" +
                                      initMap?.low_thesold
                                  ]
                                }
                              </h6>
                              <div
                                onMouseEnter={() => settooltip2(true)}
                                onMouseLeave={() => settooltip2(false)}
                              >
                                {tooltip2 ? (
                                  <Tooltip
                                    value={
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.low_thesold
                                      ] > 0
                                        ? localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.low_thesold
                                          ]
                                        : 10
                                    }
                                    max={4}
                                  />
                                ) : null}{" "}
                                <span>0.1</span>{" "}
                                <input
                                  type="range"
                                  style={{
                                    accentColor: "#8ec0fc",
                                    width: "230px",
                                  }}
                                  value={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.low_thesold
                                    ] > 0
                                      ? localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.low_thesold
                                        ]
                                      : 10
                                  }
                                  min={0.1}
                                  max={4}
                                  step={0.1}
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap.low_thesold}`,
                                      `${e.target.value}`
                                    );
                                  }}
                                />{" "}
                                <span>4</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                onMouseEnter={() => settooltip2(true)}
                                onMouseLeave={() => settooltip2(false)}
                              >
                                {tooltip2 ? (
                                  <Tooltip
                                    value={
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.low_thesold
                                      ] > 0
                                        ? localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.low_thesold
                                          ]
                                        : 10
                                    }
                                    max={4}
                                  />
                                ) : null}{" "}
                                <span>0.1</span>{" "}
                                <input
                                  type="range"
                                  style={{
                                    accentColor: "#8ec0fc",
                                    width: "230px",
                                  }}
                                  value={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.low_thesold
                                    ] > 0
                                      ? localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.low_thesold
                                        ]
                                      : 10
                                  }
                                  min={0.1}
                                  max={4}
                                  step={0.1}
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap.low_thesold}`,
                                      `${e.target.value}`
                                    );
                                  }}
                                />{" "}
                                <span>4</span>
                              </div>
                              <h6
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("Low Threshold")}:{" "}
                                {
                                  localState[
                                    locationData?.esp_id +
                                      "/" +
                                      initMap?.low_thesold
                                  ]
                                }
                              </h6>
                            </>
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            color: "black",
                            fontSize: "92%",
                          }}
                        >
                          {i18n.language === "en" ? (
                            <>
                              <h6
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("High Threshold")}:{" "}
                                {
                                  localState[
                                    locationData?.esp_id +
                                      "/" +
                                      initMap?.high_thesold
                                  ]
                                }
                              </h6>
                              <div
                                onMouseEnter={() => settooltip3(true)}
                                onMouseLeave={() => settooltip3(false)}
                              >
                                {tooltip3 ? (
                                  <Tooltip
                                    value={
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.high_thesold
                                      ] > 0
                                        ? localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.high_thesold
                                          ]
                                        : 10
                                    }
                                    max={20}
                                  />
                                ) : null}{" "}
                                <span>4</span>{" "}
                                <input
                                  type="range"
                                  style={{
                                    accentColor: "#8ec0fc",
                                    width: "230px",
                                  }}
                                  min={4}
                                  max={20}
                                  step={0.1}
                                  value={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.high_thesold
                                    ] > 0
                                      ? localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.high_thesold
                                        ]
                                      : 10
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap.high_thesold}`,
                                      `${e.target.value}`
                                    );
                                  }}
                                />{" "}
                                <span>20</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                onMouseEnter={() => settooltip3(true)}
                                onMouseLeave={() => settooltip3(false)}
                              >
                                {tooltip3 ? (
                                  <Tooltip
                                    value={
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.high_thesold
                                      ] > 0
                                        ? localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.high_thesold
                                          ]
                                        : 10
                                    }
                                    max={4}
                                  />
                                ) : null}{" "}
                                <span>4</span>{" "}
                                <input
                                  type="range"
                                  style={{
                                    accentColor: "#8ec0fc",
                                    width: "230px",
                                  }}
                                  min={4}
                                  max={20}
                                  step={0.1}
                                  value={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.high_thesold
                                    ] > 0
                                      ? localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.high_thesold
                                        ]
                                      : 10
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap.high_thesold}`,
                                      `${e.target.value}`
                                    );
                                  }}
                                />{" "}
                                <span>20</span>
                              </div>
                              <h6
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("High Threshold")}:{" "}
                                {
                                  localState[
                                    locationData?.esp_id +
                                      "/" +
                                      initMap?.high_thesold
                                  ]
                                }
                              </h6>
                            </>
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            color: "black",
                            fontSize: "92%",
                          }}
                        >
                          {i18n.language === "en" ? (
                            <>
                              <h6
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("Offset")}:{" "}
                                {
                                  localState[
                                    locationData?.esp_id + "/" + initMap?.offset
                                  ]
                                }
                              </h6>
                              <div
                                onMouseEnter={() => settooltip4(true)}
                                onMouseLeave={() => settooltip4(false)}
                              >
                                {tooltip4 ? (
                                  <Tooltip
                                    value={
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.offset
                                      ] !== undefined
                                        ? localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.offset
                                          ]
                                        : 0
                                    }
                                    max={1}
                                  />
                                ) : null}
                                <span>0</span>{" "}
                                <input
                                  type="range"
                                  style={{
                                    accentColor: "#8ec0fc",
                                    width: "230px",
                                  }}
                                  min={0}
                                  max={1}
                                  step={0.001}
                                  value={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.offset
                                    ] !== undefined
                                      ? localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.offset
                                        ]
                                      : 0
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap.offset}`,
                                      `${e.target.value}`
                                    );
                                  }}
                                />{" "}
                                <span>1</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                onMouseEnter={() => settooltip4(true)}
                                onMouseLeave={() => settooltip4(false)}
                              >
                                {tooltip4 ? (
                                  <Tooltip
                                    value={
                                      localState[
                                        locationData?.esp_id +
                                          "/" +
                                          initMap?.offset
                                      ] !== undefined
                                        ? localState[
                                            locationData?.esp_id +
                                              "/" +
                                              initMap?.offset
                                          ]
                                        : 0
                                    }
                                    max={1}
                                  />
                                ) : null}
                                <span>0</span>{" "}
                                <input
                                  type="range"
                                  style={{
                                    accentColor: "#8ec0fc",
                                    width: "230px",
                                  }}
                                  min={0}
                                  max={1}
                                  step={0.001}
                                  value={
                                    localState[
                                      locationData?.esp_id +
                                        "/" +
                                        initMap?.offset
                                    ] !== undefined
                                      ? localState[
                                          locationData?.esp_id +
                                            "/" +
                                            initMap?.offset
                                        ]
                                      : 0
                                  }
                                  onChange={(e) => {
                                    sendData(
                                      `${locationData?.esp_id}/${initMap.offset}`,
                                      `${e.target.value}`
                                    );
                                  }}
                                />{" "}
                                <span>1</span>
                              </div>
                              <h6
                                style={{
                                  color: "#8ec0fc",
                                  fontSize: "92%",
                                  fontWeight: "500",
                                }}
                              >
                                {t("Offset")}:{" "}
                                {
                                  localState[
                                    locationData?.esp_id + "/" + initMap?.offset
                                  ]
                                }
                              </h6>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DevicesData;
